import NP from 'number-precision'
import sysConfig from './sys-config.js'
// 乘法
export function accMul(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length
  } catch (e) {}
  try {
    m += s2.split(".")[1].length
  } catch (e) {}
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}

//除法
export function accDiv(arg1, arg2) {
  var t1 = 0,
    t2 = 0,
    r1, r2;
  try {
    t1 = arg1.toString().split(".")[1].length
  } catch (e) {}
  try {
    t2 = arg2.toString().split(".")[1].length
  } catch (e) {}
  r1 = Number(arg1.toString().replace(".", ""))
  r2 = Number(arg2.toString().replace(".", ""))
  return accMul((r1 / r2), Math.pow(10, t2 - t1));
}

//加法
export function accAdd(arg1, arg2) {
  var r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

//减法
export function accSub(arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}


// 正整数
export function validateNumber(str) {
  const reg = /^[1-9]\d*/g
  return reg.test(str)
}

/* 价格 */
export function validatePrice(str) {
  const reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/
  return reg.test(str)
}


import md5 from 'md5'
export const signKey='wZ8ZpJ8erHiO0gDa23wqykRuCwfJkR2g'
export function getSignStr(arg) {
  var result = ''
  // console.log("获取md5字符串--")
  // console.log(arg)
  if (arg) {
    var keyArr = Object.keys(arg).sort()
    // console.log(keyArr)
    var keyValueStr = ''
    for (var i = 0; i < keyArr.length; i++) {
      var keyName = keyArr[i]
      keyValueStr += keyName
      keyValueStr += arg[keyName]
    }
    keyValueStr += signKey
    // console.log('转md5的内容:' + keyValueStr)
    result = md5(keyValueStr)
  }
  // console.log('转以后的结果'+result)
  return result
}

/*
    计算供应商结算价
*/
export function settlePrice(value, rate) {
  if (!value) return '--'
  if (!/^(\d*)(\.\d{1,})?$/.test(value)) return '--'
  if (rate == '') return '--'
  if (!/^\d*(\.\d{1,})?$/.test(rate)) return '--'
  if (parseFloat(rate) < 0 || parseFloat(rate) > 100) return '--'
  rate = accDiv(rate, 100) // parseFloat(rate) / 100
  let feeRate = NP.minus(1, sysConfig.globalServiceCharge)
  let resWithoutPlatform = accMul(value, feeRate);
  let resResult = accMul(resWithoutPlatform, rate).toFixed(2)
  return resResult
}

// 去除字符串首尾空格
export function cTrim(str) {
	if (typeof str === 'string') return str.replace(/^\s*|\s*$/g, '');
  return '';
}



// WEBPACK FOOTER //
// ./src/common/tool.js